import { render } from "./CenteredQRTicketNameLabel.vue?vue&type=template&id=4b5eea4e&scoped=true"
import script from "./CenteredQRTicketNameLabel.vue?vue&type=script&lang=js"
export * from "./CenteredQRTicketNameLabel.vue?vue&type=script&lang=js"

import "./CenteredQRTicketNameLabel.vue?vue&type=style&index=0&id=4b5eea4e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4b5eea4e"

export default script